// Calls and Meetings AI: the routes and the sidebar rows of `wealth.ai.calls-meetings` (ADR-0027).
import { lazy } from 'react';
import { defineWebFeature } from '@/features/kit';

const MeetingsCard = lazy(() =>
    import('./calls-meetings.slots').then((m) => ({ default: m.MeetingsCard })),
);

export default defineWebFeature({
    id: 'wealth.ai.calls-meetings',
    routes: [
        {
            frontend: 'desk',
            path: 'calls-meetings',
            lazy: () => import('@/pages/desk/calls-meetings/page'),
        },
        {
            frontend: 'comply',
            path: 'calls-meetings',
            lazy: () => import('@/pages/comply/calls-meetings/page'),
        },
    ],
    nav: [
        // --- Tasks & Alerts ---
        {
            frontend: 'desk',
            key: 'calls-meetings',
            label: 'Calls & Meetings',
            href: '/desk/calls-meetings',
            icon: 'Phone',
            group: 'tasks-alerts',
            order: 310,
        },
        // --- Monitoring ---
        // The read of every call of the firm, with no control that writes.
        {
            frontend: 'comply',
            key: 'calls-meetings',
            label: 'Calls & Meetings',
            href: '/comply/calls-meetings',
            icon: 'Phone',
            group: 'monitoring',
            order: 435,
        },
    ],
    slots: {
        'desk.dashboard.cards': [
            {
                key: 'meetings',
                order: 20,
                span: 4,
                rows: 2,
                title: 'Upcoming client meetings',
                summary: 'The client meetings in your Outlook calendar.',
                emptyBehaviour: 'collapse',
                // With no calendar connection the card shows how to connect
                // it, so the count is not known and the card stays open.
                count: (ctx) =>
                    ctx.overview?.meetings?.calendarConnected
                        ? ctx.overview.meetings.entries.length
                        : null,
                Component: MeetingsCard,
            },
        ],
    },
});
